import {
  useEffect
} from 'react';

export const useAdSlot = ({ mapping, sizes, id, slot, isTransitioning, isLoading }) => {

  useEffect(() => {

    if (isLoading) {
      return;
    }

    /* eslint-disable valid-typeof */
    if (!isTransitioning && typeof window !== undefined) {
      const { googletag } = window;

      if (googletag && id) {
        googletag.cmd.push(() => {
          const adMapping = googletag.sizeMapping();
          Object.keys(mapping).forEach((breakpoint) => {

            adMapping.addSize([ Number(breakpoint), 0 ], [ mapping[breakpoint] ]);
          });

          const builtMapping = adMapping.build();
          const definedSlots = googletag?.pubads()?.getSlots();
          const activeSlotIds = [];

          for (let i = 0; i < definedSlots?.length; i ++) {
            activeSlotIds.push(definedSlots[i].getAdUnitPath());
          }

          if (activeSlotIds?.filter(slot_id => slot_id === slot).length === 0) {
            googletag
            .defineSlot(
              slot,
              sizes,
              id
            )
            .defineSizeMapping(builtMapping)
            .addService(googletag.pubads());
          }

          googletag.enableServices();
        });

        googletag.cmd.push(() => {
          googletag.display(id);
        });
      }
    }
  }, [ mapping, sizes, id, slot, isTransitioning, isLoading ]);
};
